export default __webpack_public_path__ + "static/media/election_voter_count.1726b984.png";